import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UtilityService} from './services/utility.service';
import {CacheService} from './services/cache.service';
import {CellRenderersService} from './services/cellRenderers.service';
import {ConstantsService} from './services/constants.service';
import {DataService} from './services/data.service';
import {CustomValidatorsService} from './services/custom-validators.service';
import {ApplicationEventsService} from './services/application-events.service';
import {NotifPollingService} from './services/notif-polling.service';
import {ContentHeightService} from './services/content-height.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [
        CustomValidatorsService,
        DataService,
        CacheService,
        CellRenderersService,
        UtilityService,
        ConstantsService,
        ApplicationEventsService,
        NotifPollingService,
        ContentHeightService
    ]
})
export class CoreModule {
}
